/**
 * Hospital portal — split-bundle entry App.
 */
import { Routes, Route, Navigate } from "react-router-dom";
import { PortalAppShell } from "@/shared/app/PortalAppShell";
import SafeRoute from "@/components/system/SafeRoute";
import { ProtectedHospitalRoute, HospitalLayout } from "@/apps/hospital";
import { HospitalLogin, HospitalCasesPage } from "@/apps/hospital/routes";
import { portalPath } from "@/shared/app/portalPath";

const S = ({ name, children }: { name: string; children: React.ReactNode }) => (
  <SafeRoute name={name}>{children}</SafeRoute>
);

const HospitalApp = () => {
  const p = portalPath("hospital");
  const layout = <ProtectedHospitalRoute><HospitalLayout /></ProtectedHospitalRoute>;
  const children = (
    <>
      <Route index element={<S name="HospitalCases"><HospitalCasesPage /></S>} />
      <Route path="dashboard" element={<Navigate to={p("/")} replace />} />
      <Route path="upcoming" element={<Navigate to={p("/")} replace />} />
      <Route path="calendar" element={<Navigate to={p("/")} replace />} />
      <Route path="notifications" element={<Navigate to={p("/")} replace />} />
      <Route path="case/:caseId" element={<Navigate to={p("/")} replace />} />
    </>
  );
  return (
    <PortalAppShell portal="hospital">
      <Routes>
        {/* Canonical (subdomain) */}
        <Route path="/login" element={<S name="HospitalLogin"><HospitalLogin /></S>} />
        <Route path="/" element={layout}>{children}</Route>
        {/* Prefixed alias (Lovable preview) */}
        <Route path="/hospital/login" element={<S name="HospitalLogin"><HospitalLogin /></S>} />
        <Route path="/hospital" element={layout}>{children}</Route>
        <Route path="*" element={<Navigate to={p("/login")} replace />} />
      </Routes>
    </PortalAppShell>
  );
};

export default HospitalApp;
